import React from 'react';
import PropTypes from 'prop-types';
import { compose, defaultProps, withHandlers } from 'recompose';

import { SelectBox } from 'components/core/SelectBox';
import './sortDropDownVariation.scss';

export function SortDropDownVariation({ options, value, handleChange }) {    
	return (
		<div className='sort-container'>
			<span className='sort-by-text'>Sort By:</span>
			<SelectBox
				id="sort-by"
				label=""
				className="sort-dropdown-variation"
				onChange={handleChange}
				options={options}
				value={value}
				key={value}
			/>
		</div>
	);
}

export const enhance = compose(
	defaultProps({
		onChange: () => {},
	}),
	withHandlers({
		handleChange: (props) => (event) => {
			props.onChange({ order: event.target.value });
		},
	}),
);

SortDropDownVariation.defaultProps = {
	options: [
		{
			value: 'recommended',
			display: 'Recommended',
		},
		{
			value: 'star_rating_sf',
			display: 'Reviews',
		},
		{
			value: 'price',
			display: 'Price',
		},
		{
			value: 'distance',
			display: 'Distance',
		},
	],
	value: 'recommended',
};

SortDropDownVariation.propTypes = {
	options: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.any,
			display: PropTypes.any,
		}),
	),
	value: PropTypes.string,
	handleChange: PropTypes.func,
};

export default enhance(SortDropDownVariation);
